import { render, staticRenderFns } from "./TextInformation.vue?vue&type=template&id=22aec87c&scoped=true&"
import script from "./TextInformation.vue?vue&type=script&lang=ts&"
export * from "./TextInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aec87c",
  null
  
)

export default component.exports